//Componet: TestingCommissiondetalis
//Description: Page to Display Testing Commission Details

import React   from 'react'
import { useSelector } from 'react-redux';
import TestingCommissionList from '../../components/testingcommission_components/TestingCommissionList'

function TestingCommissiondetalis({renderPageContent}) {
    const headerName = useSelector(state => state.authendicationReducer.headerName);
    if (headerName === 'Assets') {
        return (
            <>
                <TestingCommissionList renderPageContent={renderPageContent} />
            </>
        );
    } else {
        // If headerName doesn't match, return null or any other desired behavior
        return null; // or any other fallback component
    }
}

export default TestingCommissiondetalis;